import { useEffect, useState } from 'react';
import './style.css';
import { departmentForContactformList } from '../../utils/departments';
import contactInfo from '../../services/contact-info.json'
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { apiV1 } from '../../lib/axios';
import { getApiErrorMessage } from '../../utils/getApiErrorMessage';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { BiCheckCircle } from 'react-icons/bi';

const standardEmail = "suporte@2mpayments.com";

const contactFormSchema = z.object({
  department: z.string().min(1, 'O campo departamento é obrigatório.'),
  subject: z.string().min(1, 'O campo assunto é obrigatório.'),
  message: z.string().min(1, 'O campo mensagem é obrigatório.'),
});

export const ContactFormPage = () => {
  const { register, handleSubmit, formState: { errors }, setError } = useForm({
    resolver: zodResolver(contactFormSchema),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [receiverEmail, setReceiveEmail] = useState('');
  
  useEffect(()=>{
    if(receiverEmail === ''){
      const email = getReceiverEmail();
      setReceiveEmail(email);
    }
  },[])
  function buildFinalData(formData){
    return {receiverEmail: receiverEmail, ...formData}
  }

  async function sendForm(data){
    try {
      return await apiV1.post("/attendance/contact_support", data);
    } catch (error) {
      toast.error(getApiErrorMessage(error, 'Falha ao enviar formulário!'));
      console.error("error when send the form: ", error);
    }
  }

  const onSubmit = async (formData) => {
    const finalData = buildFinalData(formData);
    setIsLoading(true);

    const response = await sendForm(finalData);

    if (response.data.ok) {
      setIsLoading(false);
      setIsEmailSent(true);
    } else {
      toast.error('Falha ao enviar formulário. Tente novamente.');
      setIsLoading(false);
    }
  };

  function getReceiverEmail(){
    const currentChannelEmail = contactInfo.emailSac;
    return currentChannelEmail ? currentChannelEmail : standardEmail;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-700 p-4 font-sans">
      <style jsx>{`
        
      `}</style>

      <div className="floating-elements">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      <div className="form-wrapper">
        <div className="header-section">
          <div className="logo">
            Formulário de Contato
          </div>
        </div>

        <div className="form-section">
          {
            isEmailSent ?
            <div>
              <div className="flex just-center align-center mt-10">
                <div className="checkmark-container">
                  <div className="checkmark-circle">
                    <BiCheckCircle size={50} color="white" />
                  </div>
                </div>
                <h2 className='text-center'>Formulário enviado com sucesso!</h2>
              </div>
              <div className="flex flex-col mt-4">
                <p className="text-center">Obrigado por entrar em contato conosco. Sua mensagem foi recebida e nossa equipe retornará em breve.</p>
                <p className="text-center">Caso necessite enviar um novo formulário, clique no botão abaixo:</p>
                <div className="button-field mt-4 d-flex align-items-center justify-content-center">
                  <button className="back-form-btn" onClick={() => setIsEmailSent(false)}>Enviar novo formulário</button>
                </div>
              </div>
            </div> : 
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col just-center">
              <div className="form-group">
                <label htmlFor="department" className="form-label">
                  Departamento *
                </label>
                <select
                  id="department"
                  name="department"
                  {...register('department')}
                  className="form-select"
                  required
                >
                  {departmentForContactformList.map((dept, index) => (
                    <option key={index} value={dept.value} disabled={dept.disabled}>
                      {dept.label}
                    </option>
                  ))}
                </select>
                {errors.department && <span className="error">{errors.department.message}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">
                  Assunto *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  {...register('subject')}
                  className="form-input"
                  placeholder="Digite o assunto da sua mensagem..."
                  required
                />
                {errors.subject && <span className="error">{errors.subject.message}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="formMessage" className="form-label">
                  Mensagem *
                </label>
                <textarea
                  id="formMessage"
                  name="formMessage"
                  {...register('message')}
                  className="form-textarea"
                  placeholder="Descreva sua dúvida, solicitação ou comentário..."
                  required
                ></textarea>
                {errors.message && <span className="error">{errors.message.message}</span>}
              </div>

              <button 
                type="submit"
                onClick={handleSubmit}
                className="submit-btn"
                disabled={isEmailSent}
              >
                {isLoading ? 'Enviando...' : 'Enviar'}
              </button>
            </form>
          }
        </div>
      </div>
    </div>
  );
};